import * as React from 'react';
import { useTranslation } from '@/src/i18n';

const LIMITATION_ALL = 'ALL'; // All practitioners
export const LIMITATION_CENTER = 'CENTER'; // Practitioners who accept ONLY known patients
const LIMITATION_PUBLIC = 'PUBLIC'; // Practitioners who accept ALL patients

const choices = [
  {
    label: LIMITATION_ALL.toLowerCase(),
    value: LIMITATION_ALL,
  },
  {
    label: LIMITATION_PUBLIC.toLowerCase(),
    value: LIMITATION_PUBLIC,
  },
];
const TLCLimitationField = ({
  onChange,
  initialValue = LIMITATION_ALL,
}: {
  onChange: Function;
  initialValue: string;
}) => {
  const [limitation, setLimitation] = React.useState(initialValue);
  const { t } = useTranslation();
  return (
    <div className="wrapper--radio-buttons sp-aligned">
      {/* TODO : refacto with atom RadioButton */}
      {choices.map(({ label, value }) => (
        <div className="radio-button" key={value}>
          <input
            key={value}
            id={value}
            type="radio"
            name="limitation"
            checked={limitation === value}
            onChange={() => {
              setLimitation(value);
              onChange(value);
            }}
          />
          <label htmlFor={value}>{t(`tlc_limitation_${label}`)}</label>
          <div className="check" />
        </div>
      ))}
    </div>
  );
};

export default TLCLimitationField;
